import { Box, Image, Text, Center, Flex } from "@chakra-ui/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "~/assets/logo.svg";
import { WhiteOutlineButton } from "../../../_shared/Buttons";
import { useCurrentUserQuery } from "./index.generated";

export const UserSidebar = () => {
  const navigate = useNavigate();
  const [currentUserRes] = useCurrentUserQuery();
  const currentUser = currentUserRes.data?.currentUser;

  // if (!currentUser) return null;

  return (
    <Box
      width={"20%"}
      p={6}
      bgColor="#0F2446"
      color="white"
      h="100vh"
      flexGrow={0}
      top="0px"
      position="sticky"
      flexShrink={0}
    >
      <Flex justifyContent={"space-between"} flexDir="column" h="full">
        <Box>
          <Link to="/">
            <Image src={logo} marginBottom="1rem" w="24rem" />
          </Link>
          <Text>こんにちは、{currentUser?.name || "未登録"}さん。</Text>
        </Box>
        <Center>
          <Flex mb="20%" mx="10%" gap={3} direction="column" w="full">
            <NavigateButton />
            <WhiteOutlineButton
              onClick={() => {
                localStorage.removeItem("jwt_token");
                navigate("/login");
              }}
              label={"ログアウト"}
            />
          </Flex>
        </Center>
      </Flex>
    </Box>
  );
};

const NavigateButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const button =
    location.pathname === "/users" ? (
      <WhiteOutlineButton onClick={() => navigate("/")} label="コースを編集" />
    ) : (
      <WhiteOutlineButton
        onClick={() => navigate("/users")}
        label="ユーザーを編集"
      />
    );

  return button;
};
